export const wizardPostFormHiddenFields: string[] = ['affiliate'];

export const wizardPostFormHiddenFieldsWithoutPromocode: string[] = [...wizardPostFormHiddenFields, 'promocode'];
